<template>
  <div class="home clearfix">
    <Banner />
    <div class="container">
      <div class="row-1">
        <Nav />
      </div>
      <div class="row-2">
        <RouterView />
      </div>
      <div class="row-3">
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Banner from '@/components/Banner/index.vue';
import Nav from '@/components/Navbar/index.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'Home',
  components: {
    Banner,
    Nav,
    Footer,
  },
  data() {
    return {
      view: 'LoginBefore',
    };
  },
};
</script>

<style lang="scss" scoped>
.home{
  width: 100%;
  background-color: #f5fdff;
  .container {
    margin: auto;
    width: 1420px;
    .row-1 {
      margin-bottom: 20px;
    }
    .row-2{
      margin-bottom: 100px;
      .url-nav {
        margin: 36px 20px 0 0;
        width: 1060px;
      }
    }
    .row-3 {
      margin-bottom: 40px;
    }
  }
  &:after {
    content: '';
  display: table;
  }
}
</style>
